export default "__VITE_ASSET__BjrK1ZQz__ 480w, __VITE_ASSET__Ym8ljdU9__ 768w, __VITE_ASSET__D4NYig5i__ 1200w, __VITE_ASSET__CZ$2aVks__ 1920w";